export { default } from './SpotMap';
